import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { storageService } from "../Services/storage_service";
import { paramService } from "../Services/param_service";

const initialState = {
    showModal: false,
    dismissibleModal: true,
    loading: false,
    showAlert: false,
    sidebarShow: true,
    sidebarUnfoldable: false,
    showToast: false,
    offCanvasShow: false,
    tab: 0,
    variantTabs: '',
    isMobile: false,
    searchText: '',
    activeAccordion: '',
    disableSubmit: true,
    passwordInput: true,
    showLogin: false,
    showRegistro: false,
    showRepitencia: false,
    showBackdrop: false,
    showModalConfig: false,
    showModalCondiciones: false,
    showModalPoliticas: false,
    loadingData: false,
    continuar: false,
    activeStep: 0,
    openSpeedDial: true,
    showOnboarding: false,
    activeOnboardingStep: 0,
    showModalDelegaciones: false,
    showModalPermisos: false,
    showModalPregunta: false,
    disabledRespuesta: true,
    showModalContenidoMicroaprendizaje: false,
    disabledButtonContenido: false,
    setLoadingModal: false,
    activeDrawer: null, // DRAWER_TYPES
    showNuevasCapacitacionesPresenciales: false,
    selectedFilters: {
        tipos: [1], // Default Cursos
        temas: [],
        idiomas: [],
        dificultad: []
    },
}

export const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setModal: (state, action) => {
            state.showModal = action.payload;
        },
        setDismissibleModal: (state, action) => {
            state.dismissibleModal = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setAlert: (state, action) => {
            state.showAlert = action.payload;
        },
        setSideBarShow: (state, action) => {
            state.sidebarShow = action.payload;
        },
        setSideBarUnfoldable: (state, action) => {
            state.sidebarUnfoldable = action.payload;
        },
        setToast: (state, action) => {
            state.showToast = action.payload;
        },
        setOffCanvasShow: (state, action) => {
            state.offCanvasShow = action.payload;
        },
        setTab: (state, action) => {
            state.tab = action.payload;
        },
        setVarianTabs: (state, action) => {
            state.variantTabs = action.payload;
        },
        setIsmobile: (state, action) => {
            state.isMobile = action.payload;
        },
        setSearchText: (state, action) => {
            state.searchText = action.payload;
        },
        setActiveAccordion: (state, action) => {
            state.activeAccordion = action.payload;
        },
        setDisableSubmit: (state, action) => {
            state.disableSubmit = action.payload;
        },
        setPasswordInput: (state, action) => {
            state.passwordInput = action.payload;
        },
        setShowLogin: (state, action) => {
            state.showLogin = action.payload;
        },
        setShowRegistro: (state, action) => {
            state.showRegistro = action.payload;
        },
        setShowRepitencia: (state, action) => {
            state.showRepitencia = action.payload;
        },
        setShowBackdrop: (state, action) => {
            state.showBackdrop = action.payload;
        },
        setShowModalConfig: (state, action) => {
            state.showModalConfig = action.payload;
        },
        setShowModalCondiciones: (state, action) => {
            state.showModalCondiciones = action.payload;
        },
        setShowModalPoliticas: (state, action) => {
            state.showModalPoliticas = action.payload;
        },
        setLoadingData: (state, action) => {
            state.loadingData = action.payload;
        },
        setContinuar: (state, action) => {
            state.continuar = action.payload;
        },
        setActiveStep: (state, action) => {
            state.activeStep = action.payload;
        },
        setOpenSpeedDial: (state, action) => {
            state.openSpeedDial = action.payload;
        },
        setShowOnboarding: (state, action) => {
            state.showOnboarding = action.payload;
        },
        setActiveOnboardingStep: (state, action) => {
            state.activeOnboardingStep = action.payload;
        },
        setShowModalDelegaciones: (state, action) => {
            state.showModalDelegaciones = action.payload;
        },
        setShowModalPermisos: (state, action) => {
            state.showModalPermisos = action.payload;
        },
        setShowModalPregunta: (state, action) => {
            state.showModalPregunta = action.payload;
        },
        setDisabledRespuesta: (state, action) => {
            state.disabledRespuesta = action.payload;
        },
        setShowModalContenidoMicroaprendizaje: (state, action) => {
            state.showModalContenidoMicroaprendizaje = action.payload;
        },
        setDisableButtonContenido: (state, action) => {
            state.disabledButtonContenido = action.payload;
        },
        setLoadingModal: (state, action) => {
            state.loadingModal = action.payload;
        },
        resetUI: () => initialState,
        setActiveDrawer: (state, action) => {
            state.activeDrawer = action.payload;
        },
        setShowNuevasCapacitacionesPresenciales: (state, action) => {
            state.showNuevasCapacitacionesPresenciales = action.payload;
        },
        setSelectedFilters: (state, action) => {
            state.selectedFilters = action.payload;
        },
        clearSelectedFilters: (state) => {
            state.selectedFilters = {
                tipos: [1], // Default Cursos
                temas: [],
                idiomas: [],
                dificultad: []
            };
        }
    }
});

export const fetchDataInicial = createAsyncThunk(
    'ui/fetchDataInicial',
    async () => {
        await paramService.param({ grupo: 'archivos' }).then(resp => {
            if (resp.result) {
                storageService.setItem('urlFiles', resp.data);
            }
        }).catch(error => {
            console.log(error);
        });
        await paramService.param({ codigo: 'dias_reporteria' }).then(resp => {
            if (resp.result) {
                storageService.setItem('diasReporteria', resp.data[0]?.parametro);
            }
        }).catch(error => {
            console.log(error);
        });
        const logoutTime = storageService.getItem('logoutTime');
        if (!logoutTime) {
            await paramService.param({ codigo: 'logoutTime' }).then(resp => {
                if (resp.result) {
                    storageService.setItem('logoutTime', resp.data[0]?.parametro);
                }
            }).catch(error => {
                console.log(error);
            });
        }
        await paramService.param({ codigo: 'activarRenap' }).then(resp => {
            if (resp.result) {
                storageService.setItem('activarRenap', resp.data[0]?.parametro);
            }
        }).catch(error => {
            console.log(error);
        });

        await paramService.param({ codigo: 'horaInicioCampania' }).then(resp => {
            if (resp.result) {
                storageService.setItem('horaInicioCampania', resp.data[0]?.parametro);
            }
        }).catch(error => {
            console.log(error);
        });

        await paramService.param({ codigo: 'horaFinCampania' }).then(resp => {
            if (resp.result) {
                storageService.setItem('horaFinCampania', resp.data[0]?.parametro);
            }
        }).catch(error => {
            console.log(error);
        });

        await paramService.param({ codigo: 'mesesCampania' }).then(resp => {
            if (resp.result) {
                storageService.setItem('mesesCampania', resp.data[0]?.parametro);
            }
        }).catch(error => {
            console.log(error);
        });
    }
);


export const {
    setModal,
    setDismissibleModal,
    setLoading,
    setAlert,
    setSideBarShow,
    setSideBarUnfoldable,
    setToast,
    setOffCanvasShow,
    setTab,
    setVarianTabs,
    setIsmobile,
    setSearchText,
    setActiveAccordion,
    setDisableSubmit,
    setPasswordInput,
    setShowLogin,
    setShowRegistro,
    setShowRepitencia,
    setShowBackdrop,
    setShowModalConfig,
    setShowModalCondiciones,
    setShowModalPoliticas,
    setLoadingData,
    setContinuar,
    setActiveStep,
    setOpenSpeedDial,
    setShowOnboarding,
    setActiveOnboardingStep,
    setShowModalDelegaciones,
    setShowModalPermisos,
    setShowModalPregunta,
    setDisabledRespuesta,
    setShowModalContenidoMicroaprendizaje,
    setDisableButtonContenido,
    setLoadingModal,
    resetUI,
    setActiveDrawer,
    setShowNuevasCapacitacionesPresenciales,
    setSelectedFilters,
    clearSelectedFilters,
} = uiSlice.actions;

export default uiSlice.reducer;
